export function TopologyIcon({ type }) {
  const common = { fill: 'none', stroke: 'currentColor', strokeWidth: 1.8, strokeLinecap: 'round' }
  if (type === 'straight') return <svg viewBox="0 0 40 32"><path d="M6 25V7h28" {...common} /></svg>
  if (type === 'l-left') return <svg viewBox="0 0 40 32"><path d="M6 6v20h27" {...common} /></svg>
  if (type === 'l-right') return <svg viewBox="0 0 40 32"><path d="M34 6v20H7" {...common} /></svg>
  if (type === 'u') return <svg viewBox="0 0 40 32"><path d="M6 6v20h28V6" {...common} /></svg>
  return <svg viewBox="0 0 40 32"><rect x="7" y="5" width="26" height="22" rx="1" {...common} /></svg>
}
